var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('CoinIcon',{staticClass:"icon-wrapper",attrs:{"url":_vm.iconUrl}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.name)),_c('small',[_vm._v("("+_vm._s(_vm.symbol)+")")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-faade658","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/coin/CoinHeading.vue
// module id = null
// module chunks = 